// extracted by mini-css-extract-plugin
export default {"absoluteButton":"AbsoluteButton_absoluteButton__D1htG","img":"AbsoluteButton_img__NrdtT","hover":"AbsoluteButton_hover__eLlKV","focus":"AbsoluteButton_focus__JVvo5"};